import { Dropdown } from "antd";
import { useMemo } from "react";
import { IoMdCheckmark } from "react-icons/io";
import apiFactory from "../../api";
import { useChatContext } from "../../context/ChatContext";
import { useInfoUser } from "../../store/UserStore";
import { openNotificationError } from "../../utils/Utils";

const DropdownSchedule = ({ message }) => {
  const { user, languageMap } = useInfoUser();
  const { messageList, setMessageList } = useChatContext();
  const conversationOption = useMemo(() => {
    return [
      {
        key: "join",
        label: message?.nonAcceptList?.includes(user?.userId) ? (
          <div className="w-[60px]">
            {languageMap?.["message.DropdownSchedule.join"]}
          </div>
        ) : (
          <div className="flex items-center gap-[10px]">
            <div className="w-[60px]">
              {languageMap?.["message.DropdownSchedule.join"]}
            </div>{" "}
            <IoMdCheckmark />
          </div>
        ),
      },
      {
        key: "reject",
        label: message?.nonAcceptList?.includes(user?.userId) ? (
          <div className="flex items-center gap-[10px]">
            <div className="w-[60px]">
              {languageMap?.["message.DropdownSchedule.reject"]}
            </div>{" "}
            <IoMdCheckmark />
          </div>
        ) : (
          <div className="w-[60px]">
            {languageMap?.["message.DropdownSchedule.reject"]}
          </div>
        ),
      },
    ];
  }, [message?.nonAcceptList, languageMap]);

  const handleMenuClick = async (e) => {
    e.domEvent.stopPropagation();

    try {
      const result = await apiFactory.memberScheduleApi.update({
        messageScheduleId: message?.messageScheduleId,
        userId: user?.userId,
        join: e.key === "join",
      });

      if (result?.status !== 200) {
        return openNotificationError(result?.message);
      }

      messageList?.forEach((m) => {
        if (m?.messageScheduleId === message?.messageScheduleId) {
          m.nonAcceptList = result?.data?.nonAcceptList;
        }
      });
      setMessageList([...messageList]);
    } catch (error) {}
  };

  return (
    <Dropdown
      menu={{ items: conversationOption, onClick: handleMenuClick }}
      placement="bottomLeft"
      trigger={["click"]}
    >
      <button
        className="text-[#2a56b9]"
        onClick={(e) => e?.stopPropagation?.()}
      >
        {languageMap?.["message.DropdownSchedule.change"]}
      </button>
    </Dropdown>
  );
};

export { DropdownSchedule };
